(function(){
  'use strict';
  var burger=document.getElementById('ClBurger');
  var drawer=document.getElementById('ClDrawer');
  if(burger&&drawer){
    burger.addEventListener('click',function(){
      var open=drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded',open?'true':'false');
    });
    drawer.addEventListener('click',function(e){
      if(e.target.tagName==='A'){
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded','false');
      }
    });
  }
  var els=[].slice.call(document.querySelectorAll('.cl-reveal'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}
      });
    },{threshold:0.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(el){io.observe(el);});
  }else{
    els.forEach(function(el){el.classList.add('is-in');});
  }
})();
